import getRankModifiersForUnit from './getRankModifiersForUnit.js';
function modifyRankingForUnit({ rankedPositions, agentUnit, rules, gameState, hexProperties, }) {
    if (rankedPositions.length === 0) {
        return [];
    }
    const numOfAdjacentFriends = rules.getNumOfAdjacentFriendlyUnits(agentUnit, gameState);
    return rankedPositions.map((rankedPosition) => {
        return {
            ...rankedPosition,
            rank: rankedPosition.rank +
                getRankModifiersForUnit(agentUnit, numOfAdjacentFriends, rankedPosition, gameState, rules, hexProperties),
        };
    });
}
export default modifyRankingForUnit;
